<template>
  <!-- <div class="row">
    <div class="col s12"> -->
      <form @submit.prevent="handleNext">
        <div class="section">
          <div class="card z-depth-0 grey lighten-4">
            <div class="card-content">
              <span class="card-title teal-text"><span class="chip">1/6</span> Client<i class="material-icons right"
                  v-if="client && abbr">check_circle</i></span>
            </div>
            <div class="card-panel teal-text">
              <div class="row">
                <div class="col s12 m7">
                  <div class="input-field">
                    <input type="text" id="client" v-model="client" />
                    <label class="active" for="client">Client Name</label>
                  </div>
                </div>
                <div class="col s12 m5">
                  <div class="input-field">
                    <input type="text" id="client" v-model="abbr" />
                    <label class="active" for="client">Client Abbreviation</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-content">
              <span class="card-title teal-text"><span class="chip">2/6</span> Contacts<i class="material-icons right"
                  v-if="address && state && email && checkedEmailCounter === 0 && phone">check_circle</i></span>
            </div>

            <div class="card-panel">
              <div class="row">
                <div class="col s12 m7">
                  <div class="input-field">
                    <input type="text" id="address" v-model="address" />
                    <label class="active" for="address">Office Address</label>
                  </div>
                </div>
                <div class="col s12 m5">
                  <div class="input-field">
                    <select v-model="state">
                      <option value="" disabled selected></option>
                      <option v-for="(state, n) in allStates" :key="n">
                        {{ state }}
                      </option>
                    </select>
                    <label>State</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-panel">
              <div class="row">
                <div class="col s12 m7">
                  <div class="input-field">
                    <input type="email" id="email" v-model="email" class="validate" />
                     
                     <!-- Sumbmitting -->
                     <div class="progress" v-if="isChecking">
                      <div class="indeterminate"></div>
                     </div>

                    <label class="active" for="email">Email Address</label>
                    <p class="chip red lighten-5 red-text" v-if="email && !isChecking && checkedEmailCounter > 0">Sorry Email already in Use!</p>
                  </div>
                </div>
                <div class="col s12 m5">
                  <div class="input-field">
                    <input type="text" id="phone" v-model="phone" pattern="[0-9]{10,13}" class="validate" />
                    <label class="active" for="phone">Phone Number</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-content">
              <span class="card-title teal-text"><span class="chip">3/6</span> Scheme<i
                  class="material-icons right">check_circle</i></span>
            </div>

            <div class="card-panel">
              <div class="row">
                <div class="col s12">
                  <div class="input-field">
                    <input type="text" value="Private Scheme" readonly />
                  </div>
                </div>
              </div>
            </div>

            <div class="onboard-action-row is-single">
              <button class="waves-effect waves-light btn-large blue" :class="{
                disabled:
                  isSubmitting || !client || !abbr || !address || !state || !email || checkedEmailCounter > 0 || !phone,
              }">
                <i class="material-icons left">chevron_right</i>{{ isSubmitting ? "Loading..." : "Next" }}
              </button>
            </div>
          </div>
        </div>
      </form>
    <!-- </div>
  </div> -->
</template>

<script>
import { ref, onMounted, onUpdated, watchEffect } from "vue";
import getItems from "@/composables/getItems";
// import postItem from "@/composables/postItem";
import M from "materialize-css";


export default {
  name: "ProfileOnboardComponent",
  emits: ["back", "next"],
  props: ["cat", "newClient"],
  setup(props, context) {
    const isSubmitting = ref(false);
    const isChecking = ref(false);
    const error = ref(null);
    const client = ref(null);
    const abbr = ref(null);
    const address = ref(null);
    const allStates = ref([]);
    const state = ref(null);
    const email = ref(null);
    const checkedEmailCounter = ref(1); // default to 1 to disable next button
    const phone = ref(null);

    // check for back
    onMounted(() => {
      if (props?.newClient?.profile) {
        // reload
        client.value = props?.newClient?.profile?.name;
        abbr.value = props?.newClient?.profile?.abbr;
        address.value = props?.newClient?.profile?.address;
        state.value = props?.newClient?.profile?.state;
        phone.value = props?.newClient?.profile?.phone;
        email.value = props?.newClient?.profile?.email;
      }
    });

     // select
    onUpdated(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      M.FormSelect.init(elemsSelect, {});
    });

     // select
    onMounted(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      M.FormSelect.init(elemsSelect, {});
    });

    // check for back
    onMounted(() => {
      // all states
      allStates.value = [
        "Abia",
        "Adamawa",
        "Akwa Ibom",
        "Anambra",
        "Bauchi",
        "Bayelsa",
        "Benue",
        "Borno",
        "Cross River",
        "Delta",
        "Ebonyi",
        "Edo",
        "Ekiti",
        "Enugu",
        "FCT",  // Federal Capital Territory
        "Gombe",
        "Imo",
        "Jigawa",
        "Kaduna",
        "Kano",
        "Katsina",
        "Kebbi",
        "Kogi",
        "Kwara",
        "Lagos",
        "Nasarawa",
        "Niger",
        "Ogun",
        "Ondo",
        "Osun",
        "Oyo",
        "Plateau",
        "Rivers",
        "Sokoto",
        "Taraba",
        "Yobe",
        "Zamfara"
      ];

    });

    // handle netxt
    const handleNext = async () => {
      if (client.value || abbr.value || address.value || state.value || email.value || phone.value) {

        // end submit hold
        isSubmitting.value = true;

        // round up
        const newVal = {
          scheme_id: null, // added on the server (looks for private scheme id)
          cat: props.cat,
          name: client.value,
          abbr: abbr.value,
          address: address.value,
          state: state.value,
          phone: phone.value,
          email: email.value,
        };

        // final load
        context.emit("next", {
          id: "profile",
          value: newVal,
        });


        // // post item
        // const { res, err } = await postItem("client", newVal);

        // if (res.value) {
        //   // success
        //   // emit new parameters
        //   context.emit("next", {
        //     id: "profile",
        //     value: res.value.data,
        //   });
        // } else {
        //   error.value = err.value;
        //   console.log(error.value);
        // }


      } else {
        error.value = "All fields not selected"; // most unlikely
      }
      // end submit hold
      isSubmitting.value = false;
    };

    // watch upload
    watchEffect(() => {
      // if (email.value?.includes('@') && email.value?.includes('.')) {

        // search email
        isChecking.value = true;

        // always set to default
        checkedEmailCounter.value = 1;

        // check email
        (async () => {
          const { res } = await getItems(`client/email/checker?email=${email.value}`);

          if (res.value) {
            // update conter
            checkedEmailCounter.value = res.value.data;
          }

          // end checking 
          isChecking.value = false;
        })();

      // }
    });

    return {
      isSubmitting,
      isChecking,
      handleNext,
      error,
      client,
      abbr,
      address,
      allStates,
      state,
      email,
      checkedEmailCounter,
      phone,
    };
  },
};
</script>

<style scoped>
.progress {
    margin-top: -10px;
}
</style>
